/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Sub_Dashboard_Cancels_OnInputs */



/**
* | output |
* | --- |
* | "Subscription cancels on {date}." |
*
* @param {Sub_Dashboard_Cancels_OnInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_dashboard_cancels_on = /** @type {((inputs: Sub_Dashboard_Cancels_OnInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Dashboard_Cancels_OnInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Abonnement wird am ${i?.date} gekündigt.`)
	return /** @type {LocalizedString} */ (`Subscription cancels on ${i?.date}.`)
});